import { render } from "./EditMetaTitleModal.vue?vue&type=template&id=bb2160e6&scoped=true"
import script from "./EditMetaTitleModal.vue?vue&type=script&lang=js"
export * from "./EditMetaTitleModal.vue?vue&type=script&lang=js"

import "./EditMetaTitleModal.vue?vue&type=style&index=0&id=bb2160e6&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2160e6"]])

export default __exports__